"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var setCanaryHeader_1 = require("./setCanaryHeader");
var universalCookies_1 = require("./universalCookies");
var config_1 = require("./config");
function createFetchOptions(options) {
    options = options || {};
    var returnObj = tslib_1.__assign({}, options, { method: options.method || 'POST', credentials: 'include', headers: options.headers ? new Headers(options.headers) : new Headers() });
    // Update the canary headers
    setCanaryHeader_1.default(returnObj.headers);
    var config = config_1.getConfig();
    if (config.getAuthToken) {
        var authToken = config.getAuthToken();
        if (authToken) {
            returnObj.headers.append("Authorization", "Bearer " + authToken);
        }
    }
    if (config.appName) {
        returnObj.headers.append('X-Req-Source', config.appName);
    }
    if (config.useJsonNetSerializer) {
        returnObj.headers.append("X-UseJsonNetSerializer", "1");
    }
    // Server side fetching
    if (config.isServer) {
        var cookies = universalCookies_1.getCookieHeaderValue();
        if (cookies) {
            returnObj.headers.append("Cookie", cookies);
        }
    }
    return returnObj;
}
exports.default = createFetchOptions;
